import { render, staticRenderFns } from "./ReportImageTuev.vue?vue&type=template&id=5e3b6bc6&scoped=true&"
import script from "./ReportImageTuev.vue?vue&type=script&lang=ts&"
export * from "./ReportImageTuev.vue?vue&type=script&lang=ts&"
import style0 from "./ReportImageTuev.vue?vue&type=style&index=0&id=5e3b6bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b6bc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
